import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import HistoryIcon from '@mui/icons-material/History';
import { getVehicleTypeByDetailPath } from '../../constants/vehicleTypes';
import './RecentlyViewed.css';

const BASE = process.env.REACT_APP_API_BASE_URL;

export default function RecentlyViewed() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem('recentlyViewed') || '[]').slice(0, 8);
      setItems(stored);

      // Cet instantané localStorage date de la dernière visite de chaque annonce
      // et n'a pas de statut — on le récupère en un aller-retour par type de
      // véhicule plutôt qu'un appel par carte affichée.
      const byType = {};
      stored.forEach(car => {
        const vt = getVehicleTypeByDetailPath(car.detailPath || 'cars-details');
        (byType[vt.apiSegment] ||= []).push(car.id);
      });
      Promise.allSettled(
        Object.entries(byType).map(([apiSegment, ids]) =>
          axios.get(`${BASE}/api/${apiSegment.toLowerCase()}/status-batch`, { params: { ids: ids.join(',') } })
        )
      ).then(results => {
        const statusById = {};
        results.forEach(res => {
          if (res.status !== 'fulfilled') return;
          (res.value.data || []).forEach(row => { statusById[row.id] = row.status; });
        });
        setItems(prev => prev.map(car => ({ ...car, status: statusById[car.id] ?? car.status })));
      });
    } catch (_) {}
  }, []);

  const clearHistory = () => {
    localStorage.removeItem('recentlyViewed');
    setItems([]);
  };

  if (items.length === 0) return null;

  return (
    <section className="rv-section">
      <div className="rv-inner">
        <div className="rv-head">
          <HistoryIcon sx={{ fontSize: 22, color: '#5F41E4' }} />
          <h2 className="rv-title">Récemment consultés</h2>
          <button type="button" className="rv-clear-btn" onClick={clearHistory}>
            Effacer l'historique
          </button>
        </div>

        <div className="rv-scroll">
          {items.map(car => (
            <Link to={`/${car.detailPath || 'cars-details'}/${car.id}`} className="rv-card" key={`${car.detailPath || 'cars-details'}-${car.id}`}>
              <div className="rv-img-wrap">
                <img
                  src={car.image ? `${BASE}/car-images/${car.image}` : '/placeholder-car.png'}
                  alt={car.title}
                  className="rv-img"
                  loading="lazy"
                  onError={e => { e.target.src = '/placeholder-car.png'; }}
                />
                {car.status === 'Vendu' && (
                  <div className="rv-sold-ribbon">{t('soldBadge')}</div>
                )}
              </div>
              <div className="rv-info">
                <span className="rv-name">{car.title || `Voiture #${car.id}`}</span>
                {car.price && (
                  <span className="rv-price">{car.price?.toLocaleString('fr-FR')} DH</span>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
